interface CellSpan {
  colSpan?: number
  rowSpan?: number
}

const positiveSpan = (value = 1) => (Number.isInteger(value) && value > 0 ? value : 1)

export const readCellSpans = (cell: HTMLTableCellElement): CellSpan => {
  let rowSpan = cell.rowSpan
  // HTML rowspan=0 means all remaining rows in the current section.
  if (rowSpan === 0) {
    const row = cell.parentElement
    const rows = Array.from(row?.parentElement?.children || []).filter((node) => node.tagName === 'TR')
    rowSpan = rows.length - rows.indexOf(row!)
  }
  return {
    ...(cell.colSpan > 1 ? { colSpan: cell.colSpan } : {}),
    ...(rowSpan > 1 ? { rowSpan } : {}),
  }
}

export const serializeCellSpans = (cell: CellSpan) => {
  const colSpan = positiveSpan(cell.colSpan)
  const rowSpan = positiveSpan(cell.rowSpan)
  return `${colSpan > 1 ? ` colspan="${colSpan}"` : ''}${rowSpan > 1 ? ` rowspan="${rowSpan}"` : ''}`
}

// Count occupied grid positions, including cells spanning from preceding rows.
// Rowspans stop at section boundaries, while all sections share the table width.
export const getMissingCellCounts = (sections: CellSpan[][][]): number[][] => {
  let maxColumns = 0
  const grids = sections.map((rows) => {
    const grid: boolean[][] = rows.map(() => [])
    rows.forEach((cells, rowIndex) => {
      let column = 0
      cells.forEach((cell) => {
        while (grid[rowIndex][column]) column++
        const colSpan = positiveSpan(cell.colSpan)
        const rowSpan = cell.rowSpan === 0 ? rows.length - rowIndex : positiveSpan(cell.rowSpan)
        for (let r = rowIndex; r < Math.min(rows.length, rowIndex + rowSpan); r++) {
          for (let c = column; c < column + colSpan; c++) grid[r][c] = true
        }
        column += colSpan
      })
      maxColumns = Math.max(maxColumns, grid[rowIndex].length)
    })
    return grid
  })
  return grids.map((grid) => grid.map((row) => maxColumns - row.filter(Boolean).length))
}
